import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { Box, styled } from '@mui/material';

const OfferContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2.5),
  [theme.breakpoints.up('md')]: {
    padding: 0,
  },
}));

const TopSection = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  justifyContent: 'center',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

const ItemsContainer = styled('ul', {
  shouldForwardProp: (prop) => prop !== 'left',
})<{ left?: boolean }>(({ theme, left }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  margin: 0,
  [theme.breakpoints.up('md')]: {
    width: '30%',
    ...(left
      ? {
          alignItems: 'flex-end',
          textAlign: 'end',
        }
      : {}),
  },
}));

const Item = styled('li', {
  shouldForwardProp: (prop) => prop !== 'left',
})<{ left?: boolean }>(({ theme, left }) => ({
  display: 'flex',
  marginBottom: theme.spacing(4),
  '& svg': {
    marginRight: theme.spacing(1),
  },
  [theme.breakpoints.up('md')]: left
    ? {
        '& svg': {
          margin: theme.spacing(0, 0, 0, 1),
          order: 1,
        },
      }
    : {},
}));

const StyledImage = styled('img')(({ theme }) => ({
  width: 360,
  padding: theme.spacing(0, 5, 3),
  [theme.breakpoints.up('md')]: {
    maxWidth: 450,
  },
}));

interface WhyWeListProps {
  textsLeft?: string[];
  textsRight?: string[];
  icon?: string;
}

const WhyWeList = ({ textsLeft = [], textsRight = [], icon }: WhyWeListProps) => {
  return (
    <OfferContainer>
      <TopSection>
        {textsLeft.length > 0 ? (
          <ItemsContainer left>
            {textsLeft.map((text) => (
              <Item key={text} left>
                <CheckCircleOutlinedIcon color="primary" />
                <p className="typography-v1-legacy-p1">{text}</p>
              </Item>
            ))}
          </ItemsContainer>
        ) : null}

        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          {icon ? <StyledImage src={icon} alt="" loading="lazy" /> : null}
        </Box>

        {textsRight.length > 0 ? (
          <ItemsContainer>
            {textsRight.map((text) => (
              <Item key={text}>
                <CheckCircleOutlinedIcon color="primary" />
                <p className="typography-v1-legacy-p1">{text}</p>
              </Item>
            ))}
          </ItemsContainer>
        ) : null}
      </TopSection>
    </OfferContainer>
  );
};

export default WhyWeList;
